import React, { useState, useEffect, useRef } from "react";
import io from "socket.io-client";
import axios from "axios";
import "./css/chat.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import config from "../config"; // Импортируем API_URL

const socket = io(`${config.API_URL}`);

const Chat = ({ groupId, userId, username }) => {
  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState("");
  const messagesEndRef = useRef(null); // Реф для автоматической прокрутки

  useEffect(() => {
    if (!groupId) {
      console.error("❌ Ошибка: `groupId` не передан в `Chat`!");
      return;
    }

    console.log(`📢 Подключаемся к чату группы: ${groupId}`);
    socket.emit("join", { group_id: groupId });

    const handleReceiveMessage = (newMessage) => {
      console.log("📩 Новое сообщение:", newMessage);
      setMessages((prev) => [...prev, newMessage]);
    };

    socket.on("receive_message", handleReceiveMessage);

    return () => {
      console.log(`🚪 Отключаемся от чата группы: ${groupId}`);
      socket.off("receive_message", handleReceiveMessage);
    };
  }, [groupId]);

  useEffect(() => {
    if (!groupId) return;

    const fetchMessages = async () => {
      const token = localStorage.getItem("token");
      try {
        const response = await axios.get(`${config.API_URL}/chat/${groupId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setMessages(response.data);
      } catch (error) {
        console.error("❌ Ошибка загрузки сообщений:", error);
      }
    };

    fetchMessages();
  }, [groupId]);

  useEffect(() => {
    // После обновления сообщений прокручиваем вниз
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const sendMessage = () => {
    if (message.trim() !== "") {
      const messageData = {
        group_id: groupId,
        user_id: userId, // Передаём userId
        username,
        content: message,
      };

      console.log("📤 Отправка сообщения:", messageData);
      socket.emit("send_message", messageData);
      setMessage("");
    }
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };
  

  return (
    <div className="chat-container">
      <div className="main-text">Чат</div>
      <div className="chat-messages">
        {messages.length === 0 ? (
          <p className="chat-empty">💬 Сообщений пока нет. Напишите что-нибудь!</p>
        ) : (
          messages.map((msg, index) => (
            <div key={index} className="chat-message">
              <img
                src={msg.avatar ? `${config.API_URL}/uploads/${msg.avatar}` : `https://api.dicebear.com/7.x/identicon/svg?seed=${msg.username}`}
                alt="Аватар"
                className="chat-avatar"
              />
              <div className="chat-content">
                <strong className="second-text">{msg.username}</strong>: <span className="chat-text">{msg.content}</span>
                <span className="chat-time">{new Date(msg.timestamp).toLocaleTimeString()}</span>
              </div>
            </div>
          ))
        )}
        {/* Невидимый div, который тянет чат вниз */}
        <div ref={messagesEndRef} />
      </div>

      <div className="chat-input">
        <input
          type="text"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Введите сообщение..."
        />
        <button onClick={sendMessage}><FontAwesomeIcon icon={faPaperPlane } rotation={190} size="lg" className="faPaperPlane" /></button>
      </div>
    </div>
  );
};

export default Chat;
